<template>
  <div>
    <el-form label-width="90" inline size="mini">
      <el-form-item label="登录人员">
        <el-select v-model="filters.uid" placeholder="请选择登录人员">
          <el-option v-for="item in userData" :value="item.id" :label="item.name" :key="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="登录时间">
        <el-date-picker
          v-model="filters.sdate"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="IP">
        <el-input v-model="filters.ip" placeholder="请输入IP地址"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="success" @click="ue_search" icon="el-icon-search">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table size="mini" :data="logsData"
              :height="tb_height"
              stripe border>
      <el-table-column type="index"></el-table-column>
      <el-table-column prop="uid" width="120" :formatter="f_format" label="登录人员"></el-table-column>
      <el-table-column prop="ltime" :formatter="f_format" width="150" label="登录时间"></el-table-column>
      <el-table-column prop="ip" width="250" label="IP"></el-table-column>
      <el-table-column prop="companyid" :formatter="f_format" label="所属公司"></el-table-column>
    </el-table>

    <el-col :span="24" class="toolbar" style="position: absolute; bottom: 35px; z-index: 100; margin: 0;">
      <el-pagination layout="total,sizes,prev, pager, next,jumper, ->"
                     @current-change="ue_page_CurrentChange"
                     @size-change="ue_page_SizeChange"
                     :page-size="pageSize" :total="total" style="float:left;">
      </el-pagination>
    </el-col>
  </div>
</template>

<script>
  import * as Api from '../api/api'
  import Utils from '../api/Utils'


  export default {
    data() {
      return {
        logsData: [],
        filters: {
          uid: "",
          sdate: [],
          ip: ""
        },
        userData: [],
        companyData: [],
        page: 1,
        pageSize: 10,
        total: 0,
        tb_height:'400px',
        user: JSON.parse(sessionStorage.getItem("user")),
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        }
      }
    },
    mounted() {
      this.f_GetUser();
      setTimeout(()=>{
        this.f_GetLogs();
      },500);
    },
    methods: {
      ue_search() {
        this.f_GetLogs();
      },
      f_GetUser() {
        Api.GetUser({}, this.user.companyid).then(res => {
          if (res.code === 1)
            this.userData = res.data;
          this.f_GetCompany();
        });
      },
      f_GetCompany() {
        Api.GetCompany({}).then(res => {
          if (res.code === 1)
            this.companyData = res.data;
        })
      },
      f_GetLogs() {
        let parms = {
          page: this.page,
          pageSize: this.pageSize
        };
        if (this.filters.uid !== "")
          parms.uid = this.filters.uid;
        if (this.filters.ip !== "")
          parms.ip = this.filters.ip;

        if (this.filters.sdate && this.filters.sdate.length > 0) {
          parms.sltime = Utils.formatDate(this.filters.sdate[0], "yyyy-MM-dd 00:00:00");
          parms.eltime = Utils.formatDate(this.filters.sdate[1], "yyyy-MM-dd 23:59:59");
        }
        Api.GetLogs(parms, this.user.companyid).then(res => {
          if (res.code === 1) {
            this.logsData = res.data;
            this.total = res.total;
            this.f_AutoHeight();
          }
        });
      },
      ue_page_CurrentChange(page) {
        this.page = page;
        this.f_GetLogs();
      },
      ue_page_SizeChange(size) {
        this.pageSize = size;
        this.f_GetLogs();
      },
      f_format(row, column, cellValue) {
        let col = column.property;
        let result = cellValue;
        if (col === "companyid") {
          let dd = this.companyData.find(it => it.id == cellValue);
          if (dd) result = dd.name;
        }
        if (col === "ltime" && cellValue !== "") {
          result = Utils.formatDate(new Date(cellValue), "yyyy-MM-dd hh:mm:ss");
        }
        if(col==="uid"){
          let dd = this.userData.find(it => it.id == cellValue);
          if (dd) result = dd.name;
        }
        return result;
      },
      f_AutoHeight () {
        //初始化界面计算明细表格高度
        let gd = document.getElementsByClassName('el-table')[0];
        let bb = document.getElementsByClassName('toolbar')[0];
        let gh = Utils.GetElHeight(gd, bb);
        this.tb_height = '' + parseInt(gh)+'px'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Logs.vue